import { Button, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { createBrandAsync } from '../../brands/BrandSlice';
import { selectLoggedInUser } from '../../auth/AuthSlice';

export const AddBrand = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedInUser = useSelector(selectLoggedInUser);
  const [name, setName] = useState('');

  useEffect(() => {
    if (!loggedInUser?.isAdmin) {
      toast.error('Admin access required');
      navigate('/login');
    }
  }, [loggedInUser, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error('Brand name is required');
      return;
    }
    try {
      await dispatch(createBrandAsync({ name })).unwrap();
      toast.success('Brand created');
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error(err?.message || 'Failed to create brand');
    }
  };

  return (
    <Stack spacing={3} maxWidth={480} margin="0 auto" mt={4} p={2}>
      <Typography variant="h5">Create Brand</Typography>
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField
            label="Brand Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="outlined" onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button type="submit" variant="contained">
              Save
            </Button>
          </Stack>
        </Stack>
      </form>
    </Stack>
  );
};
